'use client';

import * as React from 'react';
import PropTypes from 'prop-types';
import * as PopoverPrimitive from '@radix-ui/react-popover';
import { cn } from '@helpers/styleUtils';

const Popover = PopoverPrimitive.Root;

const PopoverTrigger = PopoverPrimitive.Trigger;

const PopoverAnchor = PopoverPrimitive.Anchor;

const PopoverContent = React.forwardRef(
    ({ className, align = 'center', sideOffset = 4, ...props }, ref) => (
        <PopoverPrimitive.Portal>
            <PopoverPrimitive.Content
                ref={ref}
                align={align}
                sideOffset={sideOffset}
                className={cn(
                    'z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
                    className,
                )}
                {...props}
            />
        </PopoverPrimitive.Portal>
    ),
);

PopoverContent.displayName = PopoverPrimitive.Content.displayName;

// Define PropTypes for PopoverContent
PopoverContent.propTypes = {
    className: PropTypes.string, // Optional string for custom CSS classes
    align: PropTypes.oneOf(['start', 'center', 'end']), // Alignment options
    sideOffset: PropTypes.number, // Optional number for side offset (default: 4)
    props: PropTypes.object, // Additional props for PopoverPrimitive.Content
};

export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor };
